import Data from 'data';
import { defaultSummon } from 'logic/monster/summons';
import skillFunctions from '.';
import { skillAuraStats, skillCalc, skillFormula } from '../calc';
import { missileDamage } from '../damage';
import { defaultDPS, missileDPS } from '../dps';
import { defaultInfo } from '../skillinfo';

const functions = {};

// Raven

functions[114] = {
  summon(id, stats, level, target) {
    return defaultSummon(id, stats, level, target, {level: Math.min(99, skillFormula(Data.skills[id], 'clc2', stats, level)), untargetable: true});
  },
};

// Poison Creeper, Carrion Vine, Solar Creeper

functions[115] = {
  info(id, stats, level, target) {
    const skill = Data.skills[id];
    const monster = Data.monsters[skill.summon];
    if (!monster) return;

    const sumstats = {base: {}, skills: {}, base_skills: {}, weapon1: stats.weapon1};
    for (let i = 1; i <= 5; ++i) {
      const sid = skill[`sumskill${i}`];
      if (sid) {
        const slevel = skillCalc(skill, skill[`sumsk${i}calc`], stats, level);
        sumstats.skills[sid] = slevel;
        sumstats.base_skills[sid] = slevel;
      }
    }

    const sid = monster.skill1;
    const sumskill = Data.skills[sid];
    if (!sumskill) return;
    const func = skillFunctions[sumskill.srvdofunc || 0];
    if (!func) return;
    return (func.info || defaultInfo).call(func, sid, sumstats, sumstats.skills[sid], target);
  },
};

// Summon Spirit Wolf, Summon Dire Wolf, Summon Grizzly, Oak Sage, Heart of Wolverine, Spirit of Barbs

functions[119] = {
  summon(id, stats, level, target) {
    return defaultSummon(id, stats, level, target, {level: Math.min(99, skillFormula(Data.skills[id], 'clc2', stats, level))});
  },
  dps(id, stats, level, target, uselessInfo, allResults, allStats) {
    const skill = Data.skills[id];
    const info = allResults.druidanimal?.skills.find(sk => sk.id === '0')?.info;
    const sumStats = allStats.druidanimal;
    if (!info || !sumStats || sumStats.class !== skill.summon) return;
    const func = skillFunctions[1];
    if (!func) return;
    const modinfo = {...info};
    modinfo.animation = {...info.animation};
    modinfo.animation.hits = (modinfo.animation.hits || 1) * skillCalc(skill, skill.petmax, stats, level);
    return (func.dps || defaultDPS).call(func, Data.skills[0], sumStats, 1, target, modinfo);
  },
};

// Werewolf, Werebear, Delirium

functions[116] = {
  buff(id, stats, level) {
    const skill = Data.skills[id];
    return {
      level,
      state: skill.aurastate,
      stats: () => skillAuraStats(skill, stats, level),
    };
  },
};

// Firestorm

functions[117] = {
  damage(skill, stats, weapon, level, target) {
    return missileDamage(Data.missileByName[skill.srvmissilea], stats, weapon, level, target);
  },
  dps(id, stats, level, target, info) {
    const skill = Data.skills[id];
    const missile = Data.missileByName[skill.srvmissilea];
    if (!missile) return;
    return missileDPS(skill, missile, stats, level, target, info);
  },
};

// Twister, Tornado

functions[118] = {
  damage(skill, stats, weapon, level, target) {
    return missileDamage(Data.missileByName[skill.srvmissilea], stats, weapon, level, target);
  },
  dps(id, stats, level, target, info) {
    const skill = Data.skills[id];
    const missile = Data.missileByName[skill.srvmissilea];
    if (!missile) return;
    return missileDPS(skill, missile, stats, level, target, info);
  },
};

export default functions;
